import Service from '../../../service/api';
import store from '../../store';
import router from '../../../router/index';

const v3Data = {
  namespaced: true,
  state: {
    v3TeacherCourse: null,
    v3LessonLock: [],
    v3ExportData: [],
    v3FlipCard: [],
    v3Note: [],
    v3UserEnroll: [],
    lessonLockTestStatus: null,
  },
  mutations: {
    v3TeacherCourseDetailsOn(state, data) {
      state.v3TeacherCourse = data;
    },
    v3TeacherCourseDetailsOff(state) {
      state.v3TeacherCourse = null;
    },
    v3ExportDataOn(state, data) {
      state.v3ExportData = data;
    },
    v3ExportDataOff(state) {
      state.v3ExportData = [];
    },
    v3TeacherLessonLockOn(state, data) {
      console.log('v3TeacherLessonLockOn', data);
      state.v3LessonLock = data;
    },
    v3TeacherLessonLockOff(state) {
      state.v3LessonLock = [];
    },
    v3LessonFlipCardOn(state, data) {
      console.log('v3LessonFlipCardOn', data);
      state.v3FlipCard = data;
    },
    v3LessonFlipCardOff(state) {
      state.v3FlipCard = [];
    },
    v3LessonLockTestStatus(state, data) {
      //show lock test stat
      // console.log(data, 'v3LessonLockTest');

      state.lessonLockTestStatus = data;
    },
    v3LessonNoteOn(state, data) {
      console.log('v3LessonNoteOn', data);
      state.v3Note = data;
    },
    v3LessonNoteOff(state) {
      state.v3Note = [];
    },
    v3UserEnrollCourse(state, data) {
      state.v3UserEnroll = data;
    },
  },
  actions: {
    v3UserEnrollCourse({commit}) {
      // เรียกข้อมูลโดยใช้ codeItem
      Service.v3UserEnrollCourse()
        .then((res) => {
          commit('v3UserEnrollCourse', res.data.data);
        })
        .catch((error) => {
          console.log('v3UserEnrollCourse', error);
        });
    },
    v3TeacherCourseDetails({commit}, payload) {
      // เรียกข้อมูลโดยใช้ codeItem
      Service.v3TeacherCourseDetails(payload)
        .then((res) => {
          commit('v3TeacherCourseDetailsOn', res.data.data);
        })
        .catch((error) => {
          console.log('Error fetch template', error);
          commit('v3TeacherCourseDetailsOff');
        });
    },
    v3TeacherExport({commit}, payload) {
      // เรียกข้อมูลโดยใช้ codeItem
      Service.v3TeacherExport(payload)
        .then((res) => {
          commit('v3ExportDataOn', res.data.data);
        })
        .catch((error) => {
          console.log('Error v3TeacherExport', error);
          commit('v3ExportDataOff');
        });
    },
    v3TeacherLessonLock({commit}, payload) {
      // เรียกข้อมูลโดยใช้ codeItem
      Service.v3TeacherLessonLock(payload)
        .then((res) => {
          commit('v3TeacherLessonLockOn', res.data.data);
        })
        .catch((error) => {
          console.log('Error v3TeacherExport', error);
          commit('v3TeacherLessonLockOff');
        });
    },
    v3TeacherLessonLockUpdate({commit}, payload) {
      // เรียกข้อมูลโดยใช้ codeItem
      Service.v3TeacherLessonLockUpdate(payload)
        .then((res) => {
          commit('v3TeacherLessonLockOn', res.data.data);
        })
        .catch((error) => {
          console.log('v3TeacherLessonLockUpdate', error);
          commit('v3TeacherLessonLockOff');
        });
    },
    v3LessonFlipCard({commit}, payload) {
      // เรียกข้อมูลโดยใช้ codeItem
      Service.v3LessonFlipCard(payload)
        .then((res) => {
          commit('v3LessonFlipCardOn', res.data.data);
        })
        .catch((error) => {
          commit('v3LessonFlipCardOff');
        });
    },

    v3LessonLockStatus({commit}, payload) {
      //lock status ????
      Service.v3LessonLockStatus(payload)
        .then((res) => {
          commit('v3LessonLockTestStatus', res.data.data);
        })
        .catch((error) => {
          console.log('v3LessonLockTestStatus', error);
        });
    },

    v3LessonNote({commit}, payload) {
      Service.v3LessonNote(payload)
        .then((res) => {
          commit('v3LessonNoteOn', res.data.data);
        })
        .catch((error) => {
          console.log('v3LessonNoteOff', error);
          commit('v3LessonNoteOff', res.data.data);
        });
    },
  },

  getters: {
    v3TeacherCourseDetails(state) {
      return state.v3TeacherCourse;
    },
    v3TeacherExport(state) {
      return state.v3ExportData;
    },
    v3TeacherLessonLock(state) {
      return state.v3LessonLock;
    },
    v3LessonFlipCard(state) {
      return state.v3FlipCard;
    },
    v3LessonLockStatus(state) {
      return state.lessonLockTestStatus;
    },
    v3LessonNote(state) {
      return state.v3Note;
    },
    v3UserEnrollCourse(state) {
      return state.v3UserEnroll;
    },
  },
};

export default v3Data;
